// Event-day job roles (card 540f21a4): one platform-wide set, admins only.
import { serviceConsumer } from '../../network/ServiceConsumer';

const BASE = () => `${process.env.REACT_APP_BASE_URL}/api/admin/job-roles`;

export const listRoles = () => serviceConsumer('GET', BASE());
export const createRole = (body) => serviceConsumer('POST', BASE(), body);
export const updateRole = (id, body) => serviceConsumer('PUT', `${BASE()}/${id}`, body);
export const archiveRole = (id) => serviceConsumer('POST', `${BASE()}/${id}/archive`, {});

// serviceConsumer folds the HTTP status into its error; 409 = someone else
// changed the role since this screen read it.
export const isConflict = (err) => err?.error?.response?.status === 409 || err?.statuscode === 409;
